export default {"src":"/oferta/_next/static/media/vegan.59d6fb19.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};